import { useRouter } from 'next/router';
import { ILoginResponse } from '@/interfaces/auth/reponse';
import SSOLogin, { hasSSOLogin } from '@/views/Login/sso';
import PasswordLogin from '@/views/Login/password';
import { ILoginProps } from '@/views/Login/index';

export interface IBaseLoginProps extends ILoginProps {
    setLoginAsAdmin?: (value: boolean) => void;
    setLoginResponse: (response: ILoginResponse) => void;
    setPage: (page: 'login' | 'device-login' | 'mfa-code' | 'mfa-enable') => void;
}

const LoginComponent = (props: IBaseLoginProps) => {
    const router = useRouter();

    if (hasSSOLogin(router.pathname)) {
        return <SSOLogin {...props} />;
    }

    return <PasswordLogin {...props} />;
};

export default LoginComponent;
